export default function enabled(e) {
  if (e) return 'Enabled';
  return 'Disabled';
}
